import React from 'react';
import Banner from 'assets/svgs/unused/banner.svg';

const Chart = () => (
  <div className="box-dashboard d-flex bg-white mb-4 p-4">
    <img alt="banner" src={Banner} className="w-100" />
  </div>
);

export default Chart;
